import { axiosInstance } from "./axios";
import { IShare } from "dto/IShare";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IPackage } from "dto/IPackage";
import {
  isMockEDeliveryId,
  getMockEDeliveryMetric,
} from "components/Registry/MessagesRegister/mockEDeliveries";

const queryKeys = {
  getMetric: (id: string, kind: number) => [
    "messagesService.getMetric",
    id,
    kind,
  ],
  getShares: (id: string, kind: number) => [
    "messagesService.getShares",
    id,
    kind,
  ],
};
interface IItem {
  Id: string;
  Kind: number;
}

export interface IChangeHandle {
  Items: IItem[];
  Handled: boolean;
}

const changeHandle = (payload: IChangeHandle) => {
  return axiosInstance.post("/list/Handled", payload);
};

const useChangeHandle = () => {
  return useCustomMutation(changeHandle);
};

const getMetric = (id: string, kind: number) => {
  // Pozycje demonstracyjne rejestru e-doręczeń — metryka bez odpytywania BE.
  if (isMockEDeliveryId(id)) {
    return Promise.resolve({
      data: getMockEDeliveryMetric(id),
    } as unknown as Awaited<ReturnType<typeof axiosInstance.get>>);
  }
  return axiosInstance.get(`/message/metric?id=${id}&kind=${kind}`);
};

const useGetMetric = (id: string, kind: number) => {
  return useCustomQuery(queryKeys.getMetric(id, kind), () =>
    getMetric(id, kind)
  );
};

const downloadMetric = (payload: { id: string }) => {
  return axiosInstance.get(`/message/evidence?id=${payload.id}`);
};

const useDownloadMetric = () => {
  return useCustomMutation(downloadMetric);
};

const receiveEDelivery = (payload: {
  id: string;
}): Promise<{ data: IPackage }> => {
  return axiosInstance.get(`/message/receive?id=${payload.id}`);
};

const useReceiveEDelivery = () => {
  return useCustomMutation(receiveEDelivery);
};

const rejectEDelivery = (payload: { id: string }) => {
  return axiosInstance.post(`/message/reject?id=${payload.id}`);
};

const useRejectEDelivery = () => {
  return useCustomMutation(rejectEDelivery);
};

export interface IRedirect {
  Id: string;
  Kind: number;
  ToUserId: string;
  Title?: string;
  Content?: string;
  Keys?: [
    {
      Id: string;
      Key: string;
    }
  ];
}

const redirect = (payload: IRedirect) => {
  return axiosInstance.post("/message/pass", payload);
};

const useRedirect = () => {
  return useCustomMutation(redirect);
};

export interface ICreateShare {
  Id: string;
  Kind: number;
  ToUserId: string;
  Title?: string;
  Content?: string;
  Keys?: {
    Id: string;
    Key: string;
  }[];
}

const share = (payload: ICreateShare) => {
  return axiosInstance.post("/message/share", payload);
};

const useShare = () => {
  return useCustomMutation(share);
};

const getShares = (id: string, kind: number): Promise<{ data: IShare[] }> => {
  return axiosInstance.get(`/message/shares?id=${id}&kind=${kind}`);
};

const useGetShare = (id: string, kind: number) => {
  return useCustomQuery(queryKeys.getShares(id, kind), () =>
    getShares(id, kind)
  );
};

export interface IDeleteShare {
  Id: string;
  Kind: number;
}

const removeShare = (payload: IDeleteShare) => {
  return axiosInstance.delete("/message/share", {
    data: payload,
  });
};

const useRemoveShare = () => {
  return useCustomMutation(removeShare);
};

export default {
  useChangeHandle,
  useGetMetric,
  useDownloadMetric,
  useRedirect,
  useShare,
  useGetShare,
  useRemoveShare,
  useReceiveEDelivery,
  useRejectEDelivery,
};
